<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
                <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid"></device-switch-disabled>
            </v-flex>
        </v-layout>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}
            </div>
        </v-flex>
    </div>
</template>

<script>
export default {
    name: "CardholderDevice",
    props: {
        device: {
            type: Object,
            required: true,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
}
</script>